import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    state = 0, // 0: all, 1: normal, 2: frozen, 3: expired
    order = [],
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.getPage, {
        search,
        state,
        order,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pi, ps, pc: 0 };
};
